module.exports = __webpack_public_path__ + "img/10_High-body+GC.1ca2b3d5.png";